import { createEvent } from 'effector';

import { RequestManagementDetailState } from './RequestManagementDetailState';

export const requestManagementDetailEvent = createEvent<Partial<RequestManagementDetailState>>(
  'requestManagementDetailEvent',
);
